import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Input from 'Components/Input'
import Search from 'Components/Search'
import Select from 'Components/Select'
import User from 'EurestoClass/User'
import Utils from 'EurestoFonction/Utils'
import React from 'react'



const options = [
  {
    label: 'Besoins non calculés',
    object: {
      date_enregistrement_besoins: {
        valeur: undefined,
      }
    },
    value: 1,
  }, {
    label: 'Besoins calculés',
    object: {
      date_enregistrement_besoins: {
        valeur: undefined,
        non: true
      },
      date_confirmation_econome: {
        valeur: undefined
      }
    },
    value: 2
  },

  {
    label: 'Non confirmés',
    object: {
      date_enregistrement_besoins: {
        valeur: undefined,
        non: true
      },
      date_confirmation_econome: {
        valeur: undefined
      }
    },
    value: 3
  }, {
    label: 'Confirmés',
    object: {
      date_confirmation_econome: {
        valeur: undefined,
        non: true
      },
      date_controle: {
        valeur: undefined
      }
    },
    value: 4
  },

  {
    label: 'Non contrôlés',
    object: {
      date_confirmation_econome: {
        valeur: undefined,
        non: true
      },
      date_controle: {
        valeur: undefined
      }
    },
    value: 5
  }, {
    label: 'Contrôlés',
    object: {
      date_controle: {
        valeur: undefined,
        non: true
      },
      date_saisie_besoins_reels: {
        valeur: undefined
      }
    },
    value: 6
  },

  {
    label: 'Sorties non saisies',
    object: {
      date_controle: {
        valeur: undefined,
        non: true
      },
      date_saisie_besoins_reels: {
        valeur: undefined
      }
    },
    value: 7
  }, {
    label: 'Sorties saisies',
    object: {
      date_saisie_besoins_reels: {
        valeur: undefined,
        non: true
      },
      date_validation_besoin_reels: {
        valeur: undefined
      }
    },
    value: 8
  },

  {
    label: 'Sorties non validées',
    object: {
      date_saisie_besoins_reels: {
        valeur: undefined,
        non: true
      },
      date_validation_besoin_reels: {
        valeur: undefined
      }
    },
    value: 9
  }, {
    label: 'Sorties validées',
    object: {
      date_validation_besoin_reels: {
        valeur: undefined,
        non: true
      }
    },
    value: 10
  },
]

class SearchClient extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      search: props.search,
      key: Utils.getRandomNumber(),
    }
  }

  search = async (data, name, e, event) => {
    const search = this.state.search

    if (name === '%date_preparation') {
      if (data === '|' && !Array.isArray(search.date_preparation)) {
        search.date_preparation = [search.date_preparation, search.date_preparation]
      } else if (data !== '|' && Array.isArray(search.date_preparation)) {
        search.date_preparation = search.date_preparation[0]
      }
    }

    if (name === '?niveau') {
      delete search.date_enregistrement_besoins
      delete search.date_confirmation_econome
      delete search.date_controle
      delete search.date_saisie_besoins_reels
      delete search.date_validation_besoin_reels
      delete search.date_enregistrement_besoins_non
      delete search.date_confirmation_econome_non
      delete search.date_controle_non
      delete search.date_saisie_besoins_reels_non
      delete search.date_validation_besoin_reels_non
      const object = options.find(o => o.value === data).object
      Object.keys(object).map(key => {
        search[key] = undefined
        if (object[key].non) {
          search[key + '_non'] = true
        }
      })
    }

    search[name] = data
    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(search))
  }

  render () {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5, overflow: 'visible' }}
            justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>
        <Select
          title={EurestoI18n.t('reservation:Date Préparation')}
          name={'%date_preparation'}
          value={this.state.search['%date_preparation']}
          onChange={this.search}
          autoComplete={false}
          options={[{
            label: 'Après le',
            value: '>'
          }, {
            label: 'Entre',
            value: '|'
          }, {
            label: 'Avant le',
            value: '<'
          }]}
        />
        <DatePicker value={this.state.search['date_preparation']}
                    range={this.state.search['%date_preparation'] === '|'}
                    title={EurestoI18n.t('commun:Date Préparation')}
                    onChange={this.search}
                    name={'date_preparation'}/>
        <Input
          onChange={this.search}
          name="libelle_responsable"
          type="text"
          className="upText"
          value={this.state.search.libelle_responsable}
          title={EurestoI18n.t('crm:Responsable')}
        />
        <Input
          onChange={this.search}
          name="libelle_atelier_classe"
          type="text"
          className="upText"
          value={this.state.search.libelle_atelier_classe}
          title={EurestoI18n.t('crm:Classe/Action FC')}
        />
        <Input
          onChange={this.search}
          name="libelle_type_activite"
          type="text"
          className="upText"
          value={this.state.search.libelle_type_activite}
          title={EurestoI18n.t('crm:Activité')}
        />
        <Input
          onChange={this.search}
          name="libelle_lieu_destination"
          type="text"
          className="upText"
          value={this.state.search.libelle_lieu_destination}
          title={EurestoI18n.t('crm:Destination')}
        />
        <Select
          title={EurestoI18n.t('reservation:Niveau')}
          name={'?niveau'}
          value={this.state.search['?niveau']}
          onChange={this.search}
          autoComplete={false}
          options={options}
        />
      </Grid>
    )
  }

}

export default class extends React.Component {

  render () {
    return <Search raz={true} defaultSearch={this.props.defaultSearch} path={'gestion'} requete={'dbm'}
                   search={this.props.search || 'gestion_dbm_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchClient/>
    </Search>
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Search/Dbm.js